/* =========================================================
   ELZIRA — LUXURY SCROLL ANIMATIONS
   ========================================================= */

document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(
    "#MainContent > .shopify-section"
  );

  if (!sections.length) {
    console.log("ELZIRA: No homepage sections found.");
    return;
  }

  sections.forEach(function (section, index) {

    section.classList.add("elzira-reveal");

    section.style.setProperty(
      "--elzira-delay",
      Math.min(index * 0.08, 0.4) + "s"
    );

  });

  const observer = new IntersectionObserver(
    function (entries, observer) {

      entries.forEach(function (entry) {

        if (entry.isIntersecting) {

          entry.target.classList.add(
            "elzira-reveal-visible"
          );

          observer.unobserve(entry.target);

        }

      });

    },
    {
      threshold: 0.12,
      rootMargin: "0px 0px -50px 0px"
    }
  );

  sections.forEach(function (section) {
    observer.observe(section);
  });

  console.log(
    "ELZIRA: Animation system loaded — " +
    sections.length +
    " sections detected."
  );

});